import { useEffect, useState, useRef } from 'react';
import { verifyLogin } from '../auth/auth';

export default function LoginCallback() {
	const [errorMessage, setErrorMessage] = useState(null);
	const [isVerifying, setIsVerifying] = useState(false);
	const verificationAttempted = useRef(false);

	console.log('Login callback page loaded!');

	useEffect(() => {
		let isMounted = true;

		async function handleVerification() {
			// Prevent multiple verification attempts across remounts
			if (verificationAttempted.current || isVerifying) {
				return;
			}

			verificationAttempted.current = true;
			setIsVerifying(true);
			
			try {
				const result = await verifyLogin();
				
				if (!isMounted) {
					return;
				}

				if (!result.success && result.error) {
					console.log('Login failed with error:', result.error);
					setErrorMessage(result.error);
				}
			} catch (error) {
				console.error('Error during verification:', error);
				if (!isMounted) return;
				setErrorMessage(error.message || 'An unexpected error occurred');
			} finally {
				if (isMounted) {
					console.log('Verification process completed');
					setIsVerifying(false);
				}
			}
		}

		handleVerification();

		return () => {
			isMounted = false;
		};
	}, []);

	if (errorMessage) {
		return (
			<article>
				<span>{errorMessage}</span>
				<br />
				<br />
				<a href="/">Return to Home</a>
			</article>
		);
	}

	return (
		<article>
			<div>Verifying login...</div>
			<div style={{ fontSize: '0.8em', color: '#666', marginTop: '10px' }}>
				<a href="/">Return to home</a>
			</div>
		</article>
	);
}
